import { Badge } from '@shopify/polaris';

const TONE_BY_STATUS: Record<string, any> = {
  ok: 'success',
  success: 'success',
  warning: 'warning',
  degraded: 'warning',
  critical: 'critical',
  error: 'critical',
  disabled: 'info',
  running: 'info',
  completed: 'success',
  fresh: 'success',
  pending: 'attention',
  live: 'success',
  sandbox: 'warning',
  paused: 'info',
};

const LABEL_BY_STATUS: Record<string, string> = {
  ok: 'Ок',
  success: 'Ок',
  warning: 'Увага',
  degraded: 'Увага',
  running: 'Виконується',
  completed: 'Виконано',
  fresh: 'Актуальна',
  critical: 'Критично',
  error: 'Помилка',
  disabled: 'Вимкнено',
  pending: 'Очікує',
  live: 'Ок',
  sandbox: 'Тест',
  paused: 'Пауза',
};

export function StatusBadge({ status, label }: { status?: string | null; label?: string }) {
  const normalized = String(status || 'disabled').toLowerCase();
  return (
    <span className="admin-status-badge">
      <Badge tone={TONE_BY_STATUS[normalized] || 'info'}>
        {label || LABEL_BY_STATUS[normalized] || normalized}
      </Badge>
    </span>
  );
}
